import { render, staticRenderFns } from "./ConnectedBanksTable.vue?vue&type=template&id=273a04a4&scoped=true&"
import script from "./ConnectedBanksTable.vue?vue&type=script&lang=js&"
export * from "./ConnectedBanksTable.vue?vue&type=script&lang=js&"
import style0 from "./ConnectedBanksTable.vue?vue&type=style&index=0&id=273a04a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273a04a4",
  null
  
)

export default component.exports